const { createSlice } = require('@reduxjs/toolkit');
const actionType = require('redux/actions/actionConstant').default;

const initialState = {
    customSenderEmail: null,
    teamMember: null,
    webhooks: [],
};

export const settingsSlice = createSlice({
    initialState,
    name: 'settings',
    reducers: {
        setCustomSenderEmail: (state, action) => {
            let payload = null;

            if (action?.payload) {
                payload = { ...action.payload };
                payload['email'] = action?.payload?.email ?? action?.payload?.emailAddress;
            }

            state.customSenderEmail = payload;
        },
        setCompanyMembers: (state, action) => {
            state.teamMember = action.payload;
        },
        setWebhooks: (state, action) => {
            state.webhooks = action.payload;
        },
    },
    extraReducers: (builder) => {
        // Clear cached settings on logout so the next user/company starts fresh.
        builder.addCase(actionType.RESET_ALL_REDUCERS, () => initialState);
    },
});

export const { setCustomSenderEmail, setCompanyMembers, setWebhooks } = settingsSlice.actions;

export default settingsSlice.reducer;
